import React, { useEffect, useState } from "react";
import { SoftrAiText } from "./svgs/SoftrAiText";
import tinycolor from "tinycolor2";
import "./styles.css";

interface SoftrBadgeProps {
    aiApp?: boolean;
}

export const FloatingBadge: React.FC<SoftrBadgeProps> = ({ aiApp = false }) => {
    const [darkTheme, setDarkTheme] = useState(false);

    useEffect(() => {
        function handleScroll() {
            const sections = document.querySelectorAll("div[data-block] > :first-child") || [];

            for (const section of sections) {
                const rect = section.getBoundingClientRect();

                if (isAtViewportEightyPercent(rect)) {
                    const isLight = hasLightBackground(section);
                    setDarkTheme(isLight);
                    break;
                }
            }
        }

        /** Updates the badge color based on the background of the current section */
        setTimeout(handleScroll, 1000);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const baseClass = `made-with-softr ${aiApp ? "ai-app" : ""} ${darkTheme ? "dark-theme" : ""}`;
    const linkStyle = {
        padding: aiApp ? "8px 12px" : "6px 8px",
        ...(darkTheme ? { background: aiApp ? "#000000" : "#1f2b3f", color: aiApp ? "#AEAEB5" : "#FFFFFF" } : {}),
    };
    const imgStyle = { margin: `0 ${aiApp ? "6px" : "4px"}` };

    return (
        <div className={baseClass} role="complementary" data-testid="floating-badge">
            {aiApp ? <AiAppBadge linkStyle={linkStyle} imgStyle={imgStyle} /> : <AppBadge isDarkTheme={darkTheme} />}
        </div>
    );
};

const AiAppBadge: React.FC<{ linkStyle: React.CSSProperties; imgStyle: React.CSSProperties }> = ({
    linkStyle,
    imgStyle,
}) => (
    <a
        href="https://www.softr.io/ai-app-generator"
        target="_blank"
        rel="noreferrer"
        title="Free AI No Code App Builder | Portals | Internal Tools"
        style={linkStyle}
    >
        <span className="made-with">Made with</span>
        <img
            src="https://assets.softr-files.com/assets/images/softr_logo/softr-ai-logo.svg"
            alt="Free AI No Code App Builder | Portals | Internal Tools"
            style={imgStyle}
        />
        <SoftrAiText className="softr-ai-text" />
    </a>
);

const AppBadge: React.FC<{ isDarkTheme: boolean }> = ({ isDarkTheme }) => {
    const imgSrc = isDarkTheme
        ? "https://assets.softr-files.com/assets/images/softr_logo/badge-variant-dark.svg"
        : "https://assets.softr-files.com/assets/images/softr_logo/badge-variant-light.svg";

    return (
        <a
            href="https://www.softr.io/?via=madewithbadge"
            target="_blank"
            rel="noreferrer"
            title="Free AI No Code App Builder | Portals | Internal Tools"
            style={{ background: "transparent" }}
        >
            <img
                src={imgSrc}
                alt="Free AI No Code App Builder | Portals | Internal Tools"
                style={{ width: "141px", height: "32px" }}
            />
        </a>
    );
};

/**There is no specific reason why 80%, this was decided by discussion with the product team.
 * it was 50%, and for the long blocks, it took more time to change the badge color*/
function isAtViewportEightyPercent(rect: DOMRect) {
    const viewport = window.innerHeight / 1.25;
    return rect.top <= viewport && rect.bottom >= viewport;
}

function hasLightBackground(element: Element) {
    const backgroundColor = window.getComputedStyle(element).getPropertyValue("background-color");
    return tinycolor(backgroundColor).isLight();
}
